__turbopack_context__.v({
  "dropdownItem": "styles-module__fTVMSG__dropdownItem",
  "dropdownList": "styles-module__fTVMSG__dropdownList",
});
